var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"text-lg text-white btn-connect",class:{ 'btn-animated': !_vm.userAddress },attrs:{"type":"button"},on:{"click":_vm.handleConnect}},[(_vm.userAddress)?[_vm._v(" "+_vm._s(_vm.userAddress.slice(0, 4) + "..." + _vm.userAddress.slice(-4))+" ")]:[_vm._v(" Connect Wallet ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }